import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import claim from './modules/claim'
import collect from './modules/collect'
import expect from './modules/expect'
import service from './modules/service'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    claim,
    collect,
    expect,
    service
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js